import Vue from 'vue';
import ConfirmDialogComponent from '@/components/global/ConfirmDialog.vue';

export default {
  install(VueInstance, options = {}) {
    // Создаем div для монтирования компонента
    const dialogDiv = document.createElement('div');
    dialogDiv.id = 'global-confirm-dialog';
    document.body.appendChild(dialogDiv);

    // Создаем экземпляр Vue с vuetify, i18n и нашим компонентом
    const app = new Vue({
      vuetify: options.vuetify,
      i18n: options.i18n,
      render: h => h(ConfirmDialogComponent)
    });
    
    // Монтируем
    app.$mount(dialogDiv);
    
    // Получаем доступ к компоненту через $children
    const componentInstance = app.$children[0];

    // Глобальный метод для удобного доступа
    VueInstance.prototype.$confirm = (config) => {
      // Поддержка простого вызова с заголовком и текстом
      if (typeof config === 'string') {
        config = { title: config };
      }
      
      return componentInstance.open(config);
    };
    
    // Удобные алиасы для совместимости с SweetAlert
    VueInstance.prototype.$confirmDialog = VueInstance.prototype.$confirm;
  }
};
